<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Merchandising from "@/services/Merchandising";
import Http from "@/services/Http";
import Swal from "sweetalert2";
import TabProductTags from "@/components/tabs/tabProductTags";
import TabProductPromotions from "../../../components/tabs/tabProductPromotions.vue";
import TabProductRelated from "../../../components/tabs/tabProductRelated.vue";
import TabProductAttributes from "../../../components/tabs/tabProductAttributes.vue";
import ModalProductImageUpload from "@/components/modals/customers/modalProductImageUpload.vue";
import ModalProductImagePreview from "@/components/modals/customers/modalProductImagePreview.vue";
/**
 * Starter page
 */
export default {
  components: { 
    Layout, 
    PageHeader, 
    TabProductTags,
    TabProductAttributes,
    TabProductRelated,
    TabProductPromotions,
    ModalProductImageUpload,
    ModalProductImagePreview
  },
  page: {
    title: "Product details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Product details",
      items: [
        {
          text: "Products",
          href: "/",
        },
      ],
      showFullDescription: false,
      isCollapsed: true,
      isBusy: false,
      product_id: this.$route.params.id,
      error: null,
      categories: [],
      tags: [],
      category_id: '',
      productInfo: {
        Art_ID: '',
        Brend: '',
        Art_ImeKratko: '',
        Art_Sifra: '',
        Opis: '',
        Art_CenaP1: '',
        Art_CenaP3: '',
        Lager_Kolicina: '',
        Grupa: '',
        PodGrupa: '',
        PodPodGrupa: '',
        PopustDo: '',
        PopustOd: '',
        Garancija: '',
        CenaAkcija: '',
        image: '',
        category_id:''
      },
      showUploadModal: false,
      showPreviewModal: false,
      previewImageUrl: '',
      previewImageIndex: 0,
      
    };
  },
  middleware: "authentication",
  computed: {
    iconClass() {
      return this.isCollapsed ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down';
    },
    opisArray() {
      if (typeof this.productInfo.Opis === 'string') {
        try {
          const decodedString = this.productInfo.Opis.replace(/&quot;/g, '"')
          return JSON.parse(decodedString)
        } catch (error) {
          return []
        }
      }
      return []
    },


    productDescLines() {
      if (!this.productInfo.Opis || typeof this.productInfo.Opis !== 'string') {
        return [];
      }
      const lines = this.productInfo.Opis.trim().split('\n');
      return lines.filter(line => line.trim() !== '');
    },
    formattedRegularPrice() {
      if (!this.productInfo.Art_CenaP1) return 'N/A';
      return this.productInfo.Art_CenaP1.split(".")[0] + ' ден';
    },
    formattedClubPrice() {
      if (!this.productInfo.Art_CenaP3) return 'N/A';
      return this.productInfo.Art_CenaP3.split(".")[0] + ' ден';
    },
  },

  async created() {
    this.getProduct();
    this.getCategories();
    this.getTags();
  },
  methods: {
    toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    toggleDescription() {
      this.showFullDescription = !this.showFullDescription;
    },

    async getProduct() {
      try {
        this.isBusy = true;
        this.error = null;
        // const response = await Merchandising.getProduct(this.product_id);
        const response = await Merchandising.getProductMerch(this.product_id);
        if (response && response.data && response.data.data) {
        this.productInfo = response.data.data;
        } else {
          this.error = "Product not found";
        }
        this.category_id = this.productInfo.category_id;


        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.error = error.response?.data?.error || "Failed to load product details";
        console.error('Error loading product:', error);
      }
    },
    async getCategories() {
      try {
        const response = await Merchandising.getCategories();
        if (response && response.data && response.data.data) {
          this.categories = response.data.data;
        }
      } catch (error) {
        console.error('Error loading categories:', error);
        this.error = error.response?.data?.error || "Failed to load categories";
      }
    },
    async getTags() {
      try {
        this.isBusy = true;
        this.error = null;
        const response = await Merchandising.getTags();
        if (response && response.data && response.data.data) {
          this.tags = Array.isArray(response.data.data) ? response.data.data : [];
        } else {
          this.tags = [];
          console.warn('Invalid response structure for tags');
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.error = error.response?.data?.error || "Failed to load tags";
        this.tags = [];
        console.error('Error loading tags:', error);
      }
    },

    successmsg(message = 'Operation completed successfully!') {
      Swal.fire({
        position: "center",
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 2000,
      });
    },
    async success() {
      this.getProduct();
    },
    failedmsg(msg) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 5000, // Reduced from 50000 (50 seconds is too long)
      });
    },

    onImageUploaded(uploadData) {
      this.getProduct();
    },

    openImagePreview(imageUrl, index) {
      this.previewImageUrl = imageUrl;
      this.previewImageIndex = index;
      this.showPreviewModal = true;
    },

    onImageDeleted(imageIndex) {
      // Remove the image from the local arrays
      this.productInfo.images.splice(imageIndex, 1);
      
      // If this was the main image, set a new main image
      if (this.productInfo.image === this.previewImageUrl) {
        if (this.productInfo.images.length > 0) {
          this.productInfo.image = this.productInfo.images[0];
        } else {
          this.productInfo.image = null;
        }
      }
      
      this.showPreviewModal = false;
    },

    onSetMainImage(imageUrl) {
      this.productInfo.image = imageUrl;
      this.showPreviewModal = false;
    },

    setMainImage(imageUrl) {
      this.productInfo.image = imageUrl;
    },

  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <!-- Error Alert -->
    <div v-if="error" class="row mb-4">
      <div class="col-12">
        <div class="alert alert-danger" role="alert">
          <i class="mdi mdi-alert-circle me-2"></i>
          {{ error }}
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div v-if="isBusy" class="row mb-4">
      <div class="col-12 text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Loading product details...</p>
      </div>
    </div>

    <div v-else class="row mb-4 p-3">
      <div class="col-xl-4">
        <div class="card mh-50">
          <div class="card-body">
            <div class="text-center">
              <!-- Main Image Display -->
              <div class="main-image-container mb-4">
                <img
                    :src="productInfo.image ? productInfo.image : 'https://www.freeiconspng.com/thumbs/no-image-icon/no-image-icon-6.png'"
                    class="card-img-top main-product-image" alt="Main product image">
              </div>

              <!-- Thumbnail Gallery -->
              <div v-if="productInfo.images && productInfo.images.length > 1" class="thumbnail-gallery">
                <h6 class="text-muted mb-3">Additional Images</h6>
                <div class="d-flex justify-content-center flex-wrap gap-3">
                  <div
                      v-for="(image, index) in productInfo.images"
                      :key="index"
                      class="thumbnail-item"
                      @click="openImagePreview(image, index)"
                      style="cursor: pointer;"
                  >
                    <!-- Thumbnail Image -->
                    <div class="thumbnail-image-container">
                      <img
                          :src="image"
                          class="thumbnail-image"
                          alt="Product thumbnail"
                      />
                    </div>
                  </div>
                </div>

                <small class="text-muted d-block mt-3">
                  <i class="uil uil-mouse-alt me-1"></i>
                  Click thumbnail to preview and manage image
                </small>
              </div>

              <!-- Action Buttons -->
              <div class="action-buttons mt-4">
                <button
                    type="button"
                    class="btn btn-primary me-2"
                    @click="showUploadModal = true"
                >
                  <i class="uil uil-image-upload me-1"></i>
                  Upload Images
                </button>

              </div>
            </div>

            <hr class="my-4" />

            <!-- Product Information (unchanged) -->
            <div class="table-responsive mt-4 mb-0">
              <h5 class="text-primary">Product Information</h5>
              <div class="mt-3">
                <p class="mb-2">
                  <span class="text-strong">Product Name : </span>
                  <span class="font-size-16">{{ productInfo.Art_ImeKratko }}</span>
                </p>
              </div>

              <div class="mt-2">
                <p class="">
                  <span class="text-strong">Product ID : </span>
                  <span class="font-size-16">{{ productInfo.Art_ID }}</span>
                </p>
              </div>
              <hr>
              <div class="">
                <p class="mb-2">
                  <span class="text-strong">Category : </span>
                  <span class="font-size-16">{{ productInfo.Grupa }}</span>
                </p>
              </div>

              <div class="mt-2">
                <p class="mb-2">
                  <span class="text-strong">Brand : </span>
                  <span class="font-size-16">{{ productInfo.Brend }}</span>
                </p>
              </div>
              <div class="mt-2">
                <p class="mb-2">
                  <span class="text-strong">Warranty : </span>
                  <span class="font-size-16" v-if="productInfo.Garancija > 0">{{ productInfo.Garancija }} months</span>
                  <span class="font-size-16" v-else>No Warranty</span>
                </p>
              </div>
              <div class="mt-2">
                <p class="mb-2 font-size-16">
                  <span class="text-strong">Regular Price : </span>
                  <span class="font-size-20">{{ formattedRegularPrice }}</span>
                </p>
              </div>
              <div class="mt-2">
                <p class="mb-2 font-size-16">
                  <span class="text-strong ">Club Price : </span>
                  <span class="text-primary font-size-20">{{ formattedClubPrice }}</span>
                </p>
              </div>

              <div class="mt-2 d-none justify-content-end ">
                <p class="mb-2 font-size-18">
                  <span class="text-strong ">Stock : </span>
                  <span class="font-size-18 text-primary">{{ productInfo.Lager_Kolicina }}</span>
                </p>
              </div>

            </div>

          </div>
        </div>
      </div>

      <!-- Right column (unchanged) -->
      <div class="col-xl-8">
        <div class="card mb-0">
          <b-tabs content-class="p-4" justified class="nav-tabs-custom">
            <b-tab active>
              <template v-slot:title>
                <i class="uil uil-list-ui-alt font-size-20"></i>
                <span class="d-none d-sm-block">Description</span>
              </template>
              <template>
                <div class="row">
                  <div class="col-sm-12 col-md-8">
                    <div  class="mb-2 p-2">
                      <p class="mb-1 text-strong" v-if="productDescLines.length > 0">Description of product:</p>
                      <p v-else>No description for this product</p>
                      <ul class="lh-lg list-unstyled">
                        <li
                            v-for="(line, index) in productDescLines.slice(0, showFullDescription ? productDescLines.length : 4)"
                            :key="index"><i class="mdi mdi-minus text-primary"></i> {{ line }}</li>
                      </ul>

                      <button @click="toggleDescription" class="btn btn-primary btn-sm"
                              v-if="productDescLines.length > 3">
                        {{ showFullDescription ? 'Read Less' : 'Read More' }}
                      </button>
                    </div>
<!--                    <div class="mb-2 p-2" v-if="productInfo.source === 'Riversoft'">-->
<!--                      <p class="mb-1 text-strong" v-if="opisArray.length > 0">Description of product:</p>-->
<!--                      <p v-else>No description for this product</p>-->
<!--                      <ul class="lh-lg list-unstyled">-->
<!--                        <li-->
<!--                            v-for="(line, index) in opisArray.slice(0, showFullDescription ? opisArray.length : 4)"-->
<!--                            :key="index"><i class="mdi mdi-minus text-primary"></i> {{ line }}</li>-->
<!--                      </ul>-->

<!--                      <button @click="toggleDescription" class="btn btn-primary btn-sm"-->
<!--                              v-if="opisArray.length > 3">-->
<!--                        {{ showFullDescription ? 'Read Less' : 'Read More' }}-->
<!--                      </button>-->
<!--                    </div>-->
                  </div>
                </div>
              </template>
            </b-tab>

            <b-tab>
              <template v-slot:title>
                <i class="uil uil-ticket font-size-20"></i>
                <span class="d-none d-sm-block">Tags</span>
              </template>
              <div>
                <div class="row">
                  <TabProductTags :product_id=this.product_id />
                </div>
              </div>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <i class="uil uil-ticket font-size-20"></i>
                <span class="d-none d-sm-block">Promotions</span>
              </template>
              <div>
                <div class="row">
                  <TabProductPromotions :product_id="this.product_id"/>
                </div>
              </div>
            </b-tab>

            <b-tab>
              <template v-slot:title>
                <i class="uil uil-ticket font-size-20"></i>
                <span class="d-none d-sm-block">Related Products</span>
              </template>
              <div>
                <div class="row">
                  <TabProductRelated :product_id="this.product_id"/>
                </div>
              </div>
            </b-tab>

            <b-tab>
              <template v-slot:title>
                <i class="uil-layers font-size-20"></i>
                <span class="d-none d-sm-block">Attributes</span>
              </template>
              <div>
                <div class="row">
                  <TabProductAttributes :product_id=this.productInfo.Art_ID :category_id="this.category_id" />
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>

    <ModalProductImageUpload
        :visible="showUploadModal"
        :product-id="product_id"
        @close="showUploadModal = false"
        @uploaded="onImageUploaded"
    />

    <ModalProductImagePreview
        :visible="showPreviewModal"
        :image-url="previewImageUrl"
        :image-index="previewImageIndex"
        :product-id="product_id"
        :is-main-image="previewImageUrl === productInfo.image"
        @close="showPreviewModal = false"
        @image-deleted="onImageDeleted"
        @set-main-image="onSetMainImage"
    />
  </Layout>
</template>

<style scoped>
/* Main Image Styles */
.main-image-container {
  position: relative;
  max-width: 300px;
  margin: 0 auto;
}

.main-product-image {
  max-height: 300px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}


/* Thumbnail Gallery */
.thumbnail-gallery {
  border-top: 1px solid #e9ecef;
  padding-top: 1.5rem;
}

.thumbnail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
}



.thumbnail-image-container {
  position: relative;
  width: 80px;
  height: 80px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}



.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


/* Delete Checkbox */
.delete-checkbox {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.875rem;
}


.delete-checkbox.checked {
  color: #dc3545;
  background-color: rgba(220, 53, 69, 0.1);
}

.delete-label {
  font-size: 0.75rem;
  font-weight: 600;
}

.delete-disabled {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  color: #6c757d;
  font-size: 0.75rem;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.gap-3 {
  gap: 1rem;
}

@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
  }

  .thumbnail-image-container {
    width: 60px;
    height: 60px;
  }
}
</style>